import { Header0, Overline, UIHeading2 } from '@cian/ui-kit/typography';

import { FC } from 'react';

import { ButtonLink } from '../../components/Button';
import { Information } from '../../components/Carousel/parts/Information';

import { setNoteForTitle } from './helpers';

interface ISlideInformationProps {
  title: string | null | undefined;
  label: string | null | undefined;
  url: string | null | undefined;
  hasCommercialProperty: boolean | undefined;
}

export const SlideInformation: FC<ISlideInformationProps> = ({ title, label, url, hasCommercialProperty }) => {
  const preparedTitle = setNoteForTitle(title || '', hasCommercialProperty);

  return (
    <Information
      chooseApartment={url ? <ButtonLink href={url}>Выбрать квартиру</ButtonLink> : null}
      label={
        label ? (
          <UIHeading2 color="text-inverted-default" fontWeight="bold">
            {label}
          </UIHeading2>
        ) : null
      }
      note={
        hasCommercialProperty ? (
          <Overline color="text-inverted-default">*в проекте есть в продаже коммерческая недвижимость</Overline>
        ) : null
      }
      title={
        title ? (
          <Header0 as="h1" color="text-inverted-default" fontWeight="bold">
            {preparedTitle}
          </Header0>
        ) : null
      }
    />
  );
};
